var isObject = require('./_is-object');
var setPrototypeOf = require('./_set-proto').set;
module.exports = function (that, target, C) {
  var S = target.constructor;
  var P;
  if (S !== C && typeof S == 'function' && (P = S.prototype) !== C.prototype && isObject(P) && setPrototypeOf) {
    setPrototypeOf(that, P);
  } return that;
};



/*****************
 ** WEBPACK FOOTER
 ** ./~/core-js/modules/_inherit-if-required.js
 ** module id = 982
 ** module chunks = 0
 **/